<template>
  <button v-if="showBackBtn" @click="backTo" class="back-button">
    <back-arrow /><span>Back</span>
  </button>
</template>

<script>
import BackArrow from "@/assets/svg/back-arrow.svg";

export default {
  name: "BackButton",
  components: {
    BackArrow,
  },
  computed: {
    showBackBtn() {
      return this.$store.state.uiState.showBackBtn;
    },
  },
  methods: {
    backTo() {
      this.trackGoogleEvent("Click Back", "Back Button", "Back");

      if (this.$route.path === "/household") {
        this.$router.push("/");
      } else {
        this.$router.back();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back-button {
  * {
    display: inline;
    vertical-align: middle;
  }

  svg {
    margin-right: 0.4rem;

    @include media(">=medium") {
      display: none;
    }
  }
}
</style>
